import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Bid({ symbol_id }) {
  const socket = useContext(SocketContext);
  const [bid, setBid] = useState(0);
  const [tickColor] = useState("text-[var(--white)]");

  useEffect(() => {
    if (!socket || !symbol_id) return;

    socket.emit("giverate", symbol_id);

    const tradeListener = (data) => {
      if (data && typeof data.Bid !== "undefined") {
        setBid(data.Bid);
      }
    };

    socket.on(`trade${symbol_id}`, tradeListener);

    return () => {
      socket.off(`trade${symbol_id}`, tradeListener);
    };
  }, [socket, symbol_id]);

  let size = "text-[14px]"
  let newBid = parseFloat(bid);

  return (
    <div
      className={`${tickColor} ${size} font-semibold transition-all duration-300 `}
    >
      {newBid}
    </div>
  );
}
